import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EoFileUploadBaseComponent } from '../eo-file-upload-base/eo-file-upload-base.component';

@Component({
  selector: 'eo-file-upload',
  templateUrl: './eo-file-upload.component.html',
  styleUrl: './eo-file-upload.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoFileUploadComponent),
      multi: true,
    },
  ],
})
export class EoFileUploadComponent extends EoFileUploadBaseComponent {
  @Input() inputStyleClass?: string;

  protected getFilenamesString(): string {
    let filenamesStr = '';
    let files =
      this.uploadedFiles && this.uploadedFiles.length > 0
        ? this.uploadedFiles
        : this.files;

    files?.forEach((f) => {
      filenamesStr += f?.name ?? f?.UploadedFileName ?? '';
      filenamesStr += ', ';
    });

    filenamesStr = filenamesStr.slice(0, -2); // remove last comma
    return filenamesStr;
  }

  protected getFilenamesArray(): string[] {
    let files =
      this.uploadedFiles && this.uploadedFiles.length > 0
        ? this.uploadedFiles
        : this.files;

    return files?.map((f) => f?.name ?? f?.UploadedFileName) ?? [];
  }
}
